// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageBannerForm-commonHeaderAdmin-uUmSq {
	position: fixed !important;
}

.ImageBannerForm-adminLayout-a1HeI {
	padding-top: 64px !important;
}

.ImageBannerForm-box-mS6pQ h2 {
	font-size: 21px;
	font-weight: 600;
}

.ImageBannerForm-exportLink-thra_ {
	margin-bottom: -29px;
}

.ImageBannerForm-blockCenter-PMQPM {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ImageBannerForm-panelHeader-LRW4z {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ImageBannerForm-currencyselect-Vek17 {
	width: 100%;
	margin-right: 0px;
}

.ImageBannerForm-panelHeader-LRW4z {
	overflow: hidden;
	position: relative;
}

.ImageBannerForm-mar0-JBl2u {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ImageBannerForm-blockCenter-PMQPM {
		padding: 0px;
	}

	.ImageBannerForm-panelHeader-LRW4z {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ImageBannerForm-sideAdminPageWrapper-fSl8M {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ImageBannerForm-panelHeader-LRW4z {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ImageBannerForm-table-BCPN3 {
	display: table;
}

.ImageBannerForm-tableRow-CUVwz {
	display: table-row;
}

.ImageBannerForm-tableCell-jXjw6 {
	display: table-cell;
	float: none;
}

.ImageBannerForm-formGroup-Akye2 {
	margin-bottom: 6px;
}

.ImageBannerForm-select-zQVWR {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ImageBannerForm-noMargin-yw8sQ {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ImageBannerForm-exportLink-thra_ {
	padding-top: 10px;
	padding-right: 10px;
}

.ImageBannerForm-labelTextNew-gN0dP {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ImageBannerForm-displayInline-Eq72c {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ImageBannerForm-btnUPdate-pMlrS {
	display: inline-block;
}

.ImageBannerForm-btnModalDelete-qk11A {
	display: inline-block;
	margin-left: 15px;
}

.ImageBannerForm-radioBtn-vQXPB {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ImageBannerForm-backgroundImg-KnOeS {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ImageBannerForm-btnUPdate-pMlrS {
		display: block;
		margin-bottom: 12px;
	}

	.ImageBannerForm-btnModalDelete-qk11A {
		display: block;
		margin-left: 0px;
	}

	.ImageBannerForm-btnWidth-IdrWK {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ImageBannerForm-bannerImageBg-olQQK {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ImageBannerForm-bannerDelete-DOWOv {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ImageBannerForm-modalRoot-urt27 {
	padding: 32px;
}

.ImageBannerForm-modalBorderBottom-QmH3W {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ImageBannerForm-logInModalBody-t_maG {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ImageBannerForm-exportSection-QzIDu {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ImageBannerForm-exportSectionGridSub-OA2BJ {
	grid-template-columns: 50% 49% !important;
}

.ImageBannerForm-exportText-kZMhk {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ImageBannerForm-exportLinkImg-AqTEu {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ImageBannerForm-vtrMiddle-cGtoc {
	vertical-align: middle;
}

.ImageBannerForm-exportImg-REnUb {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ImageBannerForm-profileViewlabel-YGOJx {
	display: inline-block;
	width: 38%
}

.ImageBannerForm-profileViewMainContent-xhC9b {
	display: inline-block;
	width: 62%;
}

.ImageBannerForm-profileViewMain-PH9CB {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ImageBannerForm-profileViewInner-FbcDu {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ImageBannerForm-profileImageSection-PX8o2 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ImageBannerForm-lastviewInner-RcQTV {
	padding: 10px;
}

.ImageBannerForm-whyHostHoriLine-NQUmx {
	margin: 30px 0;
}

.ImageBannerForm-tableGrid-YheFK {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ImageBannerForm-headingContent-Qv7SU {
	font-size: 18px;
	font-weight: 500;
}

.ImageBannerForm-refundTextColor-Sy_Wf {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ImageBannerForm-dividerLine-s6uwr {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ImageBannerForm-smallContent-kKcn4 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ImageBannerForm-sideAdminPageWrapper-fSl8M {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ImageBannerForm-sideAdminPageWrapper-fSl8M {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ImageBannerForm-exportSection-QzIDu {
		grid-template-columns: 100%;
	}

	.ImageBannerForm-exportSectionGridSub-OA2BJ {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ImageBannerForm-profileViewlabel-YGOJx {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ImageBannerForm-profileViewMainContent-xhC9b {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ImageBannerForm-ChangeToUpperCase-cix4S {
	text-transform: uppercase
}

.ImageBannerForm-noBorder-KcCL2 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ImageBannerForm-siteAdminHeading-slFR9 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ImageBannerForm-siteAdminSubHeading-tv73x {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ImageBannerForm-adminFormDivider-vDz0U {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ImageBannerForm-errorMessage-qOIbz {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.ImageBannerForm-panelHeader-LRW4z {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.ImageBannerForm-formGroup-Akye2 {
  margin-bottom: 6px;
}

.ImageBannerForm-select-zQVWR {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.ImageBannerForm-labelText-UzK18 {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.ImageBannerForm-space1-nbLnZ {
	margin-bottom: 6px !important;
}

.ImageBannerForm-space2-nGyTn {
	margin-bottom: 12px !important;
}

.ImageBannerForm-space3-fpokL {
	margin-bottom: 18px !important;
}

.ImageBannerForm-space4-lTtz5 {
	margin-bottom: 24px !important;
}

.ImageBannerForm-space5-HD70B {
	margin-bottom: 30px !important;
}

.ImageBannerForm-space6-W25IV {
	margin-bottom: 36px !important;
}

.ImageBannerForm-space7-QsFAV {
	margin-bottom: 42px !important;
}

.ImageBannerForm-spaceTop8-dHHeC {
	margin-bottom: 48px !important;
}

.ImageBannerForm-spaceTop1-At7ih {
	margin-top: 6px !important;
}

.ImageBannerForm-spaceTop2-qCmq3 {
	margin-top: 12px !important;
}

.ImageBannerForm-spaceTop3-ZbV_O {
	margin-top: 18px !important;
}

.ImageBannerForm-spaceTop4-clvwP {
	margin-top: 24px !important;
}

.ImageBannerForm-spaceTop5-L06eD {
	margin-top: 30px !important;
}

.ImageBannerForm-spaceTop6-RK7H1 {
	margin-top: 36px !important;
}

.ImageBannerForm-spaceTop7-dTYD8 {
	margin-top: 42px !important;
}

.ImageBannerForm-spaceTop8-dHHeC {
	margin-top: 48px !important;
}

.ImageBannerForm-noMargin-yw8sQ {
	margin: 0px !important;
}

.ImageBannerForm-padding1-iCaDD {
	padding-bottom: 6px !important;
}

.ImageBannerForm-padding2-NnwFw {
	padding-bottom: 12px !important;
}

.ImageBannerForm-padding3-VKS0e {
	padding-bottom: 18px !important;
}

.ImageBannerForm-padding4-GSWiq {
	padding-bottom: 24px !important;
}

.ImageBannerForm-padding5-i0j5f {
	padding-bottom: 30px !important;
}

.ImageBannerForm-padding6-FkZt8 {
	padding-bottom: 36px !important;
}

.ImageBannerForm-padding7-yRvG7 {
	padding-bottom: 42px !important;
}

.ImageBannerForm-paddingTop1-Qzb8H {
	padding-top: 6px !important;
}

.ImageBannerForm-paddingTop2-kQplE {
	padding-top: 12px !important;
}

.ImageBannerForm-paddingTop3-r3EG1 {
	padding-top: 18px !important;
}

.ImageBannerForm-paddingTop4-CE3pq {
	padding-top: 24px !important;
}

.ImageBannerForm-paddingTop5-IxQHh {
	padding-top: 30px !important;
}

.ImageBannerForm-paddingTop6-k4Eba {
	padding-top: 36px !important;
}

.ImageBannerForm-paddingTop7-Ul4Y_ {
	padding-top: 42px !important;
}

.ImageBannerForm-noPadding-fMeyI {
	padding: 0px !important;
}

.ImageBannerForm-textBold-Oe9lE {
	font-weight: 500 !important;
}

.ImageBannerForm-textBolder-c56At {
	font-weight: 700 !important;
}

.ImageBannerForm-textNormal-w1FG_ {
	font-weight: normal !important;
}

.ImageBannerForm-spaceBottom20-xZ0pz {
	margin-bottom: 20px;
}

.ImageBannerForm-spaceBottom10-FLyHC {
	margin-bottom: 10px;
}

.ImageBannerForm-marginNone-_JW5Q {
	margin: 0;
}

.ImageBannerForm-spaceBottom15-rN0oG {
	margin-bottom: 15px;
}

.ImageBannerForm-marginTopNone-r7VgA {
	margin-top: 0;
}

.ImageBannerForm-spaceTop11-k8fqj {
	margin-top: 11px;
}

.ImageBannerForm-spaceTop21-dIKOC {
	margin-top: 21px;
}

.ImageBannerForm-spaceTop20-zg3CW {
	margin-top: 20px;
}

.ImageBannerForm-spaceTop10-qfvRx {
	margin-top: 10px;
}

/*New Design Text Colors */

.ImageBannerForm-textDarkBlue-YoynR {
	color: rgb(20, 39, 94) !important;
}

.ImageBannerForm-textLightBlue-wmQOd {
	color: rgb(57, 87, 106) !important;
}

.ImageBannerForm-textLightSandleGreen-m4Czy {
	color: rgb(76, 86, 41) !important;
}

.ImageBannerForm-textLightBrown-b2_ZI {
	color: rgb(115, 79, 33) !important;
}

.ImageBannerForm-textMediumMaroon-oPc8W {
	color: rgb(87, 37, 51) !important;
}

.ImageBannerForm-textBrown-wc61O {
	color: rgb(160, 47, 24) !important;
}

.ImageBannerForm-textMaroon-NyV_k {
	color: rgb(155, 49, 67) !important;
}

.ImageBannerForm-textDarkBrown-Hx8al {
	color: rgb(83, 18, 16) !important;
}

.ImageBannerForm-textMediumBrown-FNiuI {
	color: rgb(142, 28, 10) !important;
}

.ImageBannerForm-textSkyBlue-XcmBT {
	color: rgb(37, 117, 141) !important;
}

.ImageBannerForm-textGray-TLe2Y {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ImageBannerForm-commonHeaderAdmin-uUmSq`,
	"adminLayout": `ImageBannerForm-adminLayout-a1HeI`,
	"box": `ImageBannerForm-box-mS6pQ`,
	"exportLink": `ImageBannerForm-exportLink-thra_`,
	"blockCenter": `ImageBannerForm-blockCenter-PMQPM`,
	"panelHeader": `ImageBannerForm-panelHeader-LRW4z`,
	"currencyselect": `ImageBannerForm-currencyselect-Vek17`,
	"mar0": `ImageBannerForm-mar0-JBl2u`,
	"sideAdminPageWrapper": `ImageBannerForm-sideAdminPageWrapper-fSl8M`,
	"table": `ImageBannerForm-table-BCPN3`,
	"tableRow": `ImageBannerForm-tableRow-CUVwz`,
	"tableCell": `ImageBannerForm-tableCell-jXjw6`,
	"formGroup": `ImageBannerForm-formGroup-Akye2`,
	"select": `ImageBannerForm-select-zQVWR`,
	"noMargin": `ImageBannerForm-noMargin-yw8sQ`,
	"labelTextNew": `ImageBannerForm-labelTextNew-gN0dP`,
	"displayInline": `ImageBannerForm-displayInline-Eq72c`,
	"btnUPdate": `ImageBannerForm-btnUPdate-pMlrS`,
	"btnModalDelete": `ImageBannerForm-btnModalDelete-qk11A`,
	"radioBtn": `ImageBannerForm-radioBtn-vQXPB`,
	"backgroundImg": `ImageBannerForm-backgroundImg-KnOeS`,
	"btnWidth": `ImageBannerForm-btnWidth-IdrWK`,
	"bannerImageBg": `ImageBannerForm-bannerImageBg-olQQK`,
	"bannerDelete": `ImageBannerForm-bannerDelete-DOWOv`,
	"modalRoot": `ImageBannerForm-modalRoot-urt27`,
	"modalBorderBottom": `ImageBannerForm-modalBorderBottom-QmH3W`,
	"logInModalBody": `ImageBannerForm-logInModalBody-t_maG`,
	"exportSection": `ImageBannerForm-exportSection-QzIDu`,
	"exportSectionGridSub": `ImageBannerForm-exportSectionGridSub-OA2BJ`,
	"exportText": `ImageBannerForm-exportText-kZMhk`,
	"exportLinkImg": `ImageBannerForm-exportLinkImg-AqTEu`,
	"vtrMiddle": `ImageBannerForm-vtrMiddle-cGtoc`,
	"exportImg": `ImageBannerForm-exportImg-REnUb`,
	"profileViewlabel": `ImageBannerForm-profileViewlabel-YGOJx`,
	"profileViewMainContent": `ImageBannerForm-profileViewMainContent-xhC9b`,
	"profileViewMain": `ImageBannerForm-profileViewMain-PH9CB`,
	"profileViewInner": `ImageBannerForm-profileViewInner-FbcDu`,
	"profileImageSection": `ImageBannerForm-profileImageSection-PX8o2`,
	"lastviewInner": `ImageBannerForm-lastviewInner-RcQTV`,
	"whyHostHoriLine": `ImageBannerForm-whyHostHoriLine-NQUmx`,
	"tableGrid": `ImageBannerForm-tableGrid-YheFK`,
	"headingContent": `ImageBannerForm-headingContent-Qv7SU`,
	"refundTextColor": `ImageBannerForm-refundTextColor-Sy_Wf`,
	"dividerLine": `ImageBannerForm-dividerLine-s6uwr`,
	"smallContent": `ImageBannerForm-smallContent-kKcn4`,
	"ChangeToUpperCase": `ImageBannerForm-ChangeToUpperCase-cix4S`,
	"noBorder": `ImageBannerForm-noBorder-KcCL2`,
	"siteAdminHeading": `ImageBannerForm-siteAdminHeading-slFR9`,
	"siteAdminSubHeading": `ImageBannerForm-siteAdminSubHeading-tv73x`,
	"adminFormDivider": `ImageBannerForm-adminFormDivider-vDz0U`,
	"errorMessage": `ImageBannerForm-errorMessage-qOIbz`,
	"labelText": `ImageBannerForm-labelText-UzK18`,
	"space1": `ImageBannerForm-space1-nbLnZ`,
	"space2": `ImageBannerForm-space2-nGyTn`,
	"space3": `ImageBannerForm-space3-fpokL`,
	"space4": `ImageBannerForm-space4-lTtz5`,
	"space5": `ImageBannerForm-space5-HD70B`,
	"space6": `ImageBannerForm-space6-W25IV`,
	"space7": `ImageBannerForm-space7-QsFAV`,
	"spaceTop8": `ImageBannerForm-spaceTop8-dHHeC`,
	"spaceTop1": `ImageBannerForm-spaceTop1-At7ih`,
	"spaceTop2": `ImageBannerForm-spaceTop2-qCmq3`,
	"spaceTop3": `ImageBannerForm-spaceTop3-ZbV_O`,
	"spaceTop4": `ImageBannerForm-spaceTop4-clvwP`,
	"spaceTop5": `ImageBannerForm-spaceTop5-L06eD`,
	"spaceTop6": `ImageBannerForm-spaceTop6-RK7H1`,
	"spaceTop7": `ImageBannerForm-spaceTop7-dTYD8`,
	"padding1": `ImageBannerForm-padding1-iCaDD`,
	"padding2": `ImageBannerForm-padding2-NnwFw`,
	"padding3": `ImageBannerForm-padding3-VKS0e`,
	"padding4": `ImageBannerForm-padding4-GSWiq`,
	"padding5": `ImageBannerForm-padding5-i0j5f`,
	"padding6": `ImageBannerForm-padding6-FkZt8`,
	"padding7": `ImageBannerForm-padding7-yRvG7`,
	"paddingTop1": `ImageBannerForm-paddingTop1-Qzb8H`,
	"paddingTop2": `ImageBannerForm-paddingTop2-kQplE`,
	"paddingTop3": `ImageBannerForm-paddingTop3-r3EG1`,
	"paddingTop4": `ImageBannerForm-paddingTop4-CE3pq`,
	"paddingTop5": `ImageBannerForm-paddingTop5-IxQHh`,
	"paddingTop6": `ImageBannerForm-paddingTop6-k4Eba`,
	"paddingTop7": `ImageBannerForm-paddingTop7-Ul4Y_`,
	"noPadding": `ImageBannerForm-noPadding-fMeyI`,
	"textBold": `ImageBannerForm-textBold-Oe9lE`,
	"textBolder": `ImageBannerForm-textBolder-c56At`,
	"textNormal": `ImageBannerForm-textNormal-w1FG_`,
	"spaceBottom20": `ImageBannerForm-spaceBottom20-xZ0pz`,
	"spaceBottom10": `ImageBannerForm-spaceBottom10-FLyHC`,
	"marginNone": `ImageBannerForm-marginNone-_JW5Q`,
	"spaceBottom15": `ImageBannerForm-spaceBottom15-rN0oG`,
	"marginTopNone": `ImageBannerForm-marginTopNone-r7VgA`,
	"spaceTop11": `ImageBannerForm-spaceTop11-k8fqj`,
	"spaceTop21": `ImageBannerForm-spaceTop21-dIKOC`,
	"spaceTop20": `ImageBannerForm-spaceTop20-zg3CW`,
	"spaceTop10": `ImageBannerForm-spaceTop10-qfvRx`,
	"textDarkBlue": `ImageBannerForm-textDarkBlue-YoynR`,
	"textLightBlue": `ImageBannerForm-textLightBlue-wmQOd`,
	"textLightSandleGreen": `ImageBannerForm-textLightSandleGreen-m4Czy`,
	"textLightBrown": `ImageBannerForm-textLightBrown-b2_ZI`,
	"textMediumMaroon": `ImageBannerForm-textMediumMaroon-oPc8W`,
	"textBrown": `ImageBannerForm-textBrown-wc61O`,
	"textMaroon": `ImageBannerForm-textMaroon-NyV_k`,
	"textDarkBrown": `ImageBannerForm-textDarkBrown-Hx8al`,
	"textMediumBrown": `ImageBannerForm-textMediumBrown-FNiuI`,
	"textSkyBlue": `ImageBannerForm-textSkyBlue-XcmBT`,
	"textGray": `ImageBannerForm-textGray-TLe2Y`
};
module.exports = ___CSS_LOADER_EXPORT___;
